import React, { useCallback } from 'react';
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  Position,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';

const initialNodes = [
  {
    id: 'start',
    type: 'input',
    data: { label: 'Check Users Without Rating' },
    position: { x: 50, y: 150 },
    style: { background: '#6C63FF', color: 'white', border: 'none' },
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: 'initial-call',
    data: { label: 'Initial Call' },
    position: { x: 250, y: 150 },
    style: { background: '#4CAF50', color: 'white', border: 'none' },
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: 'user-replied',
    data: { label: 'User Replied?' },
    position: { x: 450, y: 150 },
    style: { background: '#FFA726', color: 'white', border: 'none' },
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: 'take-feedback',
    data: { label: 'Take Feedback & Add Rating' },
    position: { x: 650, y: 200 },
    style: { background: '#4CAF50', color: 'white', border: 'none' },
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: 'end',
    type: 'output',
    data: { label: 'End Process' },
    position: { x: 850, y: 150 },
    style: { background: '#6C63FF', color: 'white', border: 'none' },
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
];

const initialEdges = [
  { 
    id: 'e1-2', 
    source: 'start', 
    target: 'initial-call',
    animated: true,
    style: { stroke: '#6C63FF' },
  },
  { 
    id: 'e2-3', 
    source: 'initial-call', 
    target: 'user-replied',
    animated: true,
    style: { stroke: '#6C63FF' },
  },
  { 
    id: 'e3-4', 
    source: 'user-replied', 
    target: 'take-feedback',
    label: 'Yes',
    animated: true,
    style: { stroke: '#4CAF50' },
  },
  { 
    id: 'e3-5', 
    source: 'user-replied', 
    target: 'end',
    label: 'No',
    animated: true,
    style: { stroke: '#F44336' },
  },
  { 
    id: 'e4-6', 
    source: 'take-feedback', 
    target: 'end',
    animated: true,
    style: { stroke: '#6C63FF' },
  },
];

function Workflow() {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );

  return (
    <div style={{ width: '100%', height: '400px' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        fitViewOptions={{ padding: 0.2 }}
        defaultEdgeOptions={{
          type: 'smoothstep',
        }}
      >
        <Controls />
        <MiniMap />
        <Background variant="dots" gap={12} size={1} />
      </ReactFlow>
    </div>
  );
}

export default Workflow; 